import { render, staticRenderFns } from "./index-banner.vue?vue&type=template&id=19c53bcb&scoped=true&"
import script from "./index-banner.vue?vue&type=script&lang=js&"
export * from "./index-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c53bcb",
  null
  
)

export default component.exports